
import DetailComponentBase from "@/app/dynamic-components/details/details-components/detail-component.base";
import { Component } from "vue-property-decorator";
import { detailComponentLookup } from "@/app/dynamic-components/details/details-components/detail-component.lookup";
import {ruleEngine} from "@/app/services/rule.engine";

export type DetailDocumentsMetaData = unknown;

@Component({})
export default class DetailComponentTabs extends DetailComponentBase<DetailDocumentsMetaData> {
  currentTab = "";

  getDossierDetailComponent(type: string) {
    this.$store
    return detailComponentLookup.getComponentFromDictionary(type);
  }

  getChildren(){
    return this.entry?.children?.filter(child => {
      if(child.metadata.showTab === undefined || child.metadata.showTab === null || (child.metadata.showTab as string).trim() === '') return true;
      return ruleEngine.resolveRule(this.detailContext,child.metadata.showTab + '');
    }) || [];
  }
}
